export default __webpack_public_path__ + "static/media/granada.1b57ec86.png";